<script setup lang="ts">
import { ref } from "vue";
import { locale } from "../../../locale";
import { endMeeting } from "../../../actions/endMeeting";
import ToolTip from "../../ToolTip.vue";
import { goFinish } from "../../../states/finishState";
import { isSelfAdmin } from "../../../states/adminsState";
import { closeModal, endCallModal } from "../../../utils/programmingModals";

const endCall = async () => {
  if (isSelfAdmin.value) {
    endCallModal(
      () => {
        endMeeting();
        closeModal();
      },
      () => {
        goFinish("leave");
        closeModal();
      },
    );
  } else {
    goFinish("leave");
  }
};
const btn = ref<HTMLElement | null>(null);
</script>
<template>
  <button ref="btn" class="end-call-button" @click="endCall">
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.0998 11.1081L22.7309 12.8124C23.0263 13.6101 22.3217 14.4285 21.4306 14.3227L17.458 13.8512C16.456 13.7323 15.8262 12.7808 16.1503 11.8756L16.2942 11.4738C16.4562 11.0215 16.2995 10.5262 15.8552 10.3035C15.1121 9.93119 13.8178 9.44561 12.1301 9.45284C10.3813 9.46034 9.04971 9.99337 8.31766 10.3761C7.91388 10.5873 7.74583 11.027 7.84357 11.4497L7.97949 12.0376C8.18012 12.9053 7.54605 13.7551 6.60913 13.8742L2.55727 14.3893C1.63806 14.5061 0.937272 13.6442 1.29393 12.8355L2.09914 11.0097C2.62215 9.82382 3.57902 8.84451 4.86583 8.42296C6.55116 7.87085 9.17606 7.21285 12.141 7.20014C15.0142 7.18782 17.5621 7.78422 19.2459 8.31043C20.6261 8.74178 21.6207 9.81446 22.0998 11.1081Z"
        fill="white"
      />
    </svg>
    <ToolTip :placement="'top'" :reference="btn">{{ locale.leave }}</ToolTip>
  </button>
</template>
<style scoped>
.end-call-button {
  width: 44px;
  height: 44px;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  background: var(--danger-button-regular);
  backdrop-filter: blur(2px);
  border-radius: 50px;
  border: none;
  cursor: pointer;
}

.end-call-button:hover {
  background-color: var(--danger-button-hover);
}

.end-call-button:active {
  background-color: var(--danger-button-active);
}
</style>
